import React from 'react';
import { Target, CheckCircle2 } from 'lucide-react';
import { KPI_ICONS } from './constants';

export const KPICard = ({ kpi, selected, onClick }) => {
  const IconComponent = KPI_ICONS[kpi.icon] || Target;
  
  return (
    <div
      data-testid={`kpi-card-${kpi.id}`}
      onClick={onClick}
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 hover:shadow-md
        ${selected ? 'border-blue-600 bg-blue-50' : 'border-gray-200 bg-white hover:border-gray-300'}`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-lg ${selected ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600'}`}>
          <IconComponent size={24} />
        </div>
        <div className="flex-1">
          <h3 className={`font-semibold ${selected ? 'text-blue-900' : 'text-gray-900'}`}>{kpi.name}</h3>
          <p className="text-sm text-gray-600 mt-1">{kpi.issue_statement}</p>
          <div className="flex items-center gap-2 mt-2">
            <span className={`text-xs px-2 py-1 rounded-full ${
              kpi.category === 'Performance' ? 'bg-emerald-100 text-emerald-700' :
              kpi.category === 'Risk' ? 'bg-rose-100 text-rose-700' :
              kpi.category === 'Customer' ? 'bg-purple-100 text-purple-700' :
              kpi.category === 'Talent' ? 'bg-yellow-100 text-yellow-700' :
              'bg-gray-100 text-gray-700'
            }`}>
              {kpi.category}
            </span>
            <span className="text-xs text-gray-500">${kpi.baseline_per_employee.toLocaleString()}/employee baseline</span>
          </div>
        </div>
        {selected && <CheckCircle2 className="text-blue-600" size={24} />}
      </div>
    </div>
  );
};
